import { useState } from "react";
import styles from "./BoardIndex.module.css";

export default function BoardIndex(props) {
  const { changePage, totalPage } = props;

  let [currentPage, setCurrentPage] = useState(0);

  const setIndex = () => {
    const result = [];
    let start = Math.floor(currentPage / 10);

    for (let i = 0; i < 9; i++) {
      let p = start * 10 + i;
      if (p <= totalPage) {
        result.push(
          <div
            className={p == currentPage ? styles.CurIndex : styles.Index}
            onClick={() => {
              changeCurrPage(p);
            }}
            key={p + 1}
          >
            {p + 1}
          </div>
        );
      } else break;
    }
    return result;
  };

  const changeCurrPage = (p) => {
    changePage(p);
    setCurrentPage(p);
  };

  return <div className={styles.BoardIndex}>{setIndex()}</div>;
}
